import { Box, Grid } from "@mui/material";
import React, { useContext } from "react";
import DocumentGeneratorCTX from "../../context";
import AppConfig from "../../../../config";
import AddressBook from "../../../address-book";
import { isObject } from "lodash";
import { useMemo } from "react";
import MonthlyMagazine from "../../../magazine";

const GeneratedDocument = () => {
  const { SUPPORTED_DOCUMENTS_TYPES } = AppConfig;
  const { dataset, documentType } = useContext(DocumentGeneratorCTX);

  console.log(">>>> documentType ", documentType);
  console.log(">>>> dataset ", dataset["offline_data"]);

  const sanitizedDataset = useMemo(() => {
    if (isObject(dataset) && Array.isArray(dataset["offline_data"])) {
      return dataset["offline_data"];
    }
    return Array.isArray(dataset) ? dataset : [];
  }, [dataset]);

  console.log(">>>> sanitizedDataset ", sanitizedDataset);

  return (
    <Grid container direction="column" rowGap={2}>
      <Box item>
        {documentType === SUPPORTED_DOCUMENTS_TYPES.ADDRESS_BOOK && (
          <AddressBook dataset={sanitizedDataset} />
        )}
        {documentType === SUPPORTED_DOCUMENTS_TYPES.MAGAZINE && (
          <MonthlyMagazine dataset={sanitizedDataset} />
        )}
      </Box>
    </Grid>
  );
};

export default GeneratedDocument;
